import { css } from 'lit'

export default css`
    :host {
        --sapContent_HeaderShadow: 0;
        --sapPageFooter_BorderColor: transparent;
        --sapElement_BorderCornerRadius: 0;
        --sapContent_Shadow3: none;
        --_ui5_dialog_footer_height: auto;
    }

    /**  needed when placing dialog in nested z-index */
    :host(.has-custom-overlay)::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 3; /* needed bc of comment input in portal modal window */
        background-color: var(--transparent-black);
    }

    .footer {
        width: 100%;
    }
`
